<template>
  <div class="notification-container container">
    <transition-group name="bounce">
      <NotificationBar
        v-for="notification in notifications_bcast"
        :key="notification.id"
        :notification="notification"
      />
    </transition-group>
  </div>
</template>

<script>
import NotificationBar from "@/components/NotificationBar";
import { mapState } from "vuex";
export default {
  components: { NotificationBar },
  name: "NotificationContainer",
  computed: mapState("notification", ["notifications_bcast"]),
  data() {
    return {};
  }
};
</script>

<style lang="css" scoped></style>
